import React from "react";
import "../../styles/Delete.css";

const Delete = ({ onClose, onConfirm, count }) => {
  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <h2>Delete {count} {count === 1 ? "record" : "records"}?</h2>
        <p>
          Are you sure you want to delete the selected {count}{" "}
          {count === 1 ? "record" : "records"}? This action cannot be undone.
        </p>
        <div className="delete-modal-buttons">
          <button className="cancel-btn" onClick={onClose}>Cancel</button>
          <button className="confirm-btn" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
};

export default Delete;